import { Action } from '@ngrx/store';
import { VelaCompare } from '@usimweb/core/models';

export const COMPARE_VERSIONS = '[Compare] Compare Versions';
export const COMPARE_VERSIONS_FAIL = '[Compare] Compare Versions Fail';
export const COMPARE_VERSIONS_SUCCESS = '[Compare] Compare Versions Success';

export const CLEAR_COMPARE = '[Compare] Clear compare';

export class CompareVersions implements Action {
  readonly type = COMPARE_VERSIONS;
  constructor(public uuids: string[], type: string) {}
}

export class CompareVersionsFail implements Action {
  readonly type = COMPARE_VERSIONS_FAIL;
  constructor(public payload: any) {}
}

export class CompareVersionsSuccess implements Action {
  readonly type = COMPARE_VERSIONS_SUCCESS;
  constructor(public payload: VelaCompare) {}
}

export class ClearCompare implements Action {
  readonly type = CLEAR_COMPARE;
  constructor() {}
}

export type CompareActions = CompareVersions | CompareVersionsFail | CompareVersionsSuccess | ClearCompare;
